import { FileToUpload } from '@/types/app-upload-handler'

export type AppUploadHandlerState = {
  filesToUpload: Array<FileToUpload>
  simultaneousFileUpload: number
  uploadInProgress: number
  uploadQueue: Array<FileToUpload>
  uploadHint: {
    visible: boolean
    destinationFolder: string | null
    messageType: string | null
  }
}

export const state = {
  filesToUpload: [],
  simultaneousFileUpload: Number(import.meta.env.VUE_APP_SIMULTANEOUS_FILES_UPLOAD) || 2,
  uploadInProgress: 0,
  uploadQueue: [],
  uploadHint: {
    visible: false,
    destinationFolder: null,
    messageType: null,
  },
}
